import { TextInput, type TextInputProps } from "@mantine/core";
import classNames from "classnames";
import type { CommonFormFieldItemProps } from "../FormField";
import { FormFieldLabel } from "../FormFieldLabel";
import { FormFieldRightSection } from "../FormFieldRightSection";

interface FormFieldTextInputProps
  extends CommonFormFieldItemProps, TextInputProps {
  type: "text" | "email";
}

function FormFieldTextInput({
  helpText,
  highlight,
  isBetaFeature,
  type,
  warned,
  ...fieldSpecificProps
}: FormFieldTextInputProps) {
  return (
    <TextInput
      {...fieldSpecificProps}
      aria-label={
        typeof fieldSpecificProps.label === "string"
          ? fieldSpecificProps.label
          : undefined
      }
      className={classNames("FormFieldTextInput", fieldSpecificProps.className)}
      defaultValue={undefined}
      label={
        fieldSpecificProps.label && (
          <FormFieldLabel
            helpText={helpText}
            highlight={highlight}
            isBetaFeature={isBetaFeature}
            label={fieldSpecificProps.label}
            required={fieldSpecificProps.required}
          />
        )
      }
      labelProps={{ w: "100%", ...fieldSpecificProps.labelProps }}
      rightSection={
        <FormFieldRightSection
          rightSection={fieldSpecificProps.rightSection}
          warned={warned}
        />
      }
      value={fieldSpecificProps.value || fieldSpecificProps.defaultValue || ""}
    />
  );
}

export { FormFieldTextInput, FormFieldTextInputProps };
